import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type SetUserCountryOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
};

export const setUserCountry = async <TFunctions>(
  options: SetUserCountryOptions<TFunctions>,
): Promise<void> => {
  const { functions, httpsCallable } = options;
  const callable = httpsCallable<void, void>(
    functions,
    'users-setLocationOnSignup',
  );

  await callable();
};
